import React from 'react';
import classNames from 'classnames';
import Button from 'react-bootstrap/Button';

import styles from './Panel.module.scss';


interface PanelProps {
  renderPanelContent?: () => React.ReactNode,
};

interface PanelState {
  isDisabled: boolean,
  isOpen: boolean,
};

class Panel extends React.Component<PanelProps, PanelState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      isDisabled: this.props.renderPanelContent ? false : true,
      isOpen: false,
    };
  }

  public render() {
    const panelStyle = this.state.isOpen
      ? styles.panelOpen
      : styles.panelClosed;

    const panelToggleIcon = this.state.isOpen
      ? <i className='modus-icons'>chevron_right_thick</i>
      : <i className='modus-icons'>chevron_left_thick</i>;

    return (
      <div className={classNames('modus-panel shadow-1', styles.panel, panelStyle)}>
        <div className={styles.panelSidebar}>
          <Button
            variant='outline-secondary'
            className={styles.panelButton}
            onClick={this.onButtonClick}
            disabled={this.state.isDisabled}
          >
            <span className={styles.panelButtonIcon}>
              {panelToggleIcon}
            </span>
          </Button>
        </div>
        <div className={classNames('panel-body', styles.panelBody)}>
          {this.props.renderPanelContent ? this.props.renderPanelContent() : null}
        </div>
      </div>
    )
  }

  public componentDidUpdate = (prevProps: PanelProps) => {
    if (this.props.renderPanelContent
        && prevProps.renderPanelContent !== this.props.renderPanelContent) {
      this.setState({
        isDisabled: false,
        isOpen: true
      })
    } else if (!this.props.renderPanelContent
        && prevProps.renderPanelContent !== this.props.renderPanelContent) {
      this.setState({
        isDisabled: true,
        isOpen: false
      })
    }
  }

  private onButtonClick = () => {
    this.setState( p => ({
      isOpen: !p.isOpen
    }));
  }
};

export default Panel;
